import { API } from "../../api.js";
import { $, esc } from "../../ui/format.js";

const PRIORITY_DOT = { High: "neg", Medium: "", Low: "pos" };

async function renderBriefingInto(elId, apiPath, summaryFields) {
  const el = $(elId);
  if (!el) return;
  el.innerHTML = `<p style="color:var(--text-mid); font-size:12.5px;">Loading briefing…</p>`;
  let rep;
  try {
    rep = await fetch(`${API}${apiPath}`).then((x) => x.json());
  } catch (e) {
    el.innerHTML = "";
    return;
  }
  const summaryHtml = summaryFields.map(([label, fmt]) => {
    const val = fmt(rep.summary);
    return val === null || val === undefined ? "" : `
      <div class="risk-stat-box" style="min-width:130px;">
        <div class="risk-stat-label">${esc(label)}</div>
        <div class="risk-stat-value" style="font-size:18px;">${val}</div>
      </div>`;
  }).join("");
  el.innerHTML = `
    <h3 style="font-family:var(--font-display); font-size:16px; margin-bottom:12px;">Board Briefing — Month ${rep.month}</h3>
    <div class="risk-stat-row" style="margin-bottom:18px;">${summaryHtml}</div>
    ${rep.items.map((item) => `
      <div class="alert-card ${item.priority === "High" ? "critical" : item.priority === "Medium" ? "warning" : "info"}" style="align-items:flex-start;">
        <div>
          <div class="alert-category">${esc(item.priority)} Priority</div>
          <div class="alert-message">${esc(item.observation)}</div>
          <div style="color:var(--brass); font-size:12px; margin-top:5px;">→ ${esc(item.recommendation)}</div>
        </div>
      </div>
    `).join("")}
  `;
}

export { renderBriefingInto };
